import { render } from "./ListeClasse.vue?vue&type=template&id=356c7bad&ts=true"
import script from "./ListeClasse.vue?vue&type=script&lang=ts"
export * from "./ListeClasse.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__